/**
 * Cuộn tới dòng hàng đang HIỂN THỊ của một item.
 *
 * `OrderItemsTable` render CẢ bảng desktop lẫn danh sách mobile vào DOM cùng
 * lúc, chỉ ẩn/hiện qua media query — bản mobile mang tiền tố id `mobile-`
 * (xem `idPrefix` trong `OrderItemsTable`/`ComboGroupRow`). Cuộn tới bản đang
 * `display:none` là KHÔNG LÀM GÌ CẢ: thu ngân trên mobile chỉ thấy toast "kiểm
 * tra lại đơn" còn màn hình đứng im, không biết dòng nào sai.
 *
 * `offsetParent === null` là cách rẻ nhất để biết một element đang bị ẩn
 * (`display:none` ở chính nó hoặc ở bất kỳ tổ tiên nào).
 *
 * Dùng chung cho POS (`pages/POS/index.tsx`) và sửa đơn (`pages/Orders/edit.tsx`)
 * — hai trang cùng render `OrderItemsTable` nên cùng dính một lỗi; để hai bản
 * copy rời nhau là chắc chắn sẽ lệch nhau ở lần sửa sau.
 */
export function scrollToVisibleItemRow(itemId: string): void {
  const candidates = [
    document.getElementById(`pos-item-row-${itemId}`),
    document.getElementById(`mobile-pos-item-row-${itemId}`),
  ];
  const visible = candidates.find((el) => el && el.offsetParent !== null);
  visible?.scrollIntoView({ behavior: 'smooth', block: 'center' });
}
